// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__QW7Cm","filters_close":"FiltersBlock_filters_close__wesCs"};